<template>
  <form-section>
    <div class="image-box">
      <div class="image-container">
        <img class="device-image" :src="imageSrc" />
      </div>
    </div>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
export default {
  name: 'DeviceImageCard',

  components: {
    FormSection
  },

  props: {
    imageSrc: {
      required: true
    }
  }
}
</script>

<style scoped>
.image-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  width: 186px;
  height: 359px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.image-container img {
  max-width: 100%;
  max-height: 100%;
  display: inline-block;
  margin: 0 auto;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/modules/devices/components/DeviceImageCard.vue